import { Button } from "@mui/material";
import React from "react";

const SendEmailButton = ({ emailObject }) => {
  const { from, userEmail, subject, description, cc } = emailObject;

  const to = encodeURIComponent(userEmail || "");
  const ccList = Array.isArray(cc) ? cc.filter(Boolean).join(",") : "";

  const emailSubject = encodeURIComponent(subject || "No Subject");

  // Convert HTML to plain text format
  const formatBodyText = (html) => {
    let formatted = html;
    formatted = formatted.replace(/<strong>(.*?)<\/strong>/gi, "**$1**");
    formatted = formatted.replace(/<br\s*\/?>/gi, "\n");
    formatted = formatted.replace(/<\/p>/gi, "\n");
    formatted = formatted.replace(/<p[^>]*>/gi, "");
    formatted = formatted.replace(/<\/?[^>]+(>|$)/g, "");
    return formatted;
  };

  const body = encodeURIComponent(formatBodyText(description || ""));

  const getEmailComposeUrl = (fromEmail) => {
    const ccParam = ccList ? `&cc=${encodeURIComponent(ccList)}` : "";

    // Default to Gmail if fromEmail is not provided
    if (!fromEmail) {
      return `https://mail.google.com/mail/?view=cm&fs=1&to=${to}${ccParam}&su=${emailSubject}&body=${body}`;
    }

    const domain = fromEmail.split("@")[1].toLowerCase();

    if (domain.includes("gmail.com")) {
      return `https://mail.google.com/mail/?view=cm&fs=1&to=${to}${ccParam}&su=${emailSubject}&body=${body}`;
    } else if (domain.includes("yahoo.com")) {
      return `https://compose.mail.yahoo.com/?to=${to}${ccParam}&subj=${emailSubject}&body=${body}`;
    } else if (
      domain.includes("outlook.com") ||
      domain.includes("hotmail.com") ||
      domain.includes("live.com")
    ) {
      return `https://outlook.live.com/mail/0/deeplink/compose?to=${to}${ccParam}&subject=${emailSubject}&body=${body}`;
    } else if (
      domain.includes("bfiinfotech.co.in") ||
      domain.includes("secureserver.net") ||
      domain.includes("godaddy.com")
    ) {
      return `https://sso.godaddy.com/?app=email&username=${encodeURIComponent(fromEmail)}`;
    } else if (domain.includes("zoho.com")) {
      return `https://mail.zoho.com/zm/#compose?to=${to}&cc=${encodeURIComponent(ccList)}&subject=${emailSubject}&body=${body}`;
    } else {
      // Fallback to Gmail
      return `https://mail.google.com/mail/?view=cm&fs=1&to=${to}${ccParam}&su=${emailSubject}&body=${body}`;
    }
  };

  const handleSendEmail = () => {
    const url = getEmailComposeUrl(from);
    if (url) {
      window.open(url, "_blank");
    }
  };

  return (
    <Button variant="contained" color="primary" onClick={handleSendEmail}>
      📧 Send Email
    </Button>
  );
};

export default SendEmailButton;
